import React from 'react';
import styled from 'styled-components';
import { GlobalUXState } from 'components/GlobalUXState';

export const NoBuildingData = () => {
  return (
    <NoBuildingDataOuter>
      <NoBuildingDataContainer>
        <GlobalUXState
          variant="noData"
          title="No properties available"
          description="There are no properties to display yet."
          compact
        />
      </NoBuildingDataContainer>
    </NoBuildingDataOuter>
  );
};

const NoBuildingDataOuter = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  padding: 32px 24px 48px;
`;

const NoBuildingDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 420px;
  text-align: center;
  box-sizing: border-box;
`;
